import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { GeneralService } from './general.service';
import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { IUser } from '../views/user/User';
import { StoreService } from './store.service';
import { EDIServices } from './edi.services';
import { Page } from '../model/page';

@Injectable()
export class UserService
  extends GeneralService
  implements EDIServices<Observable<IUser>, IUser, number>
{
  private store: StoreService;

  constructor(protected http: HttpClient) {
    super(http);

    this.store = new StoreService('users', 'id');
  }

  getStore(): StoreService {
    return this.store;
  }

  getById(id: number): Observable<IUser> {
    if (id === 0) {
      return Observable.of(this.initialize());
    } else {
      const user = this.store.getById(id);
      if (user) {
        return Observable.of(user);
      } else {
        const url = `${this.apiUrl}/users/${id}`;
        return this.http
          .get(url)
          .map((data) => this.extractPayload(data))
          .do((data) => this.store.add(data))
          .catch(this.handleError);
      }
    }
  }

  save(user: IUser, isCreate: boolean): Observable<IUser> {
    if (user.id === 0 || isCreate) {
      return this.create(user);
    }
    return this.update(user);
  }

  loginUser(loginData) {
    const url = `${this.apiUrl + '/login'}`;
    return this.http.post<any>(url, loginData).catch(this.handleError);
  }

  changePassword(data) {
    const url = `${this.apiUrl + '/users/change-password/'}`;
    return this.http.put(url, data).catch(this.handleError);
  }

  changePasswordAdmin(data) {
    const url = `${this.apiUrl + '/users/admin-change-password/'}`;
    return this.http.put(url, data).catch(this.handleError);
  }

  public getUsers(page: Page): Observable<any> {
    let params = new HttpParams();
    params = params.append('perPage', page.size.toString());
    params = params.append('page', page.pageNumber.toString());
    if (!_.isUndefined(page.sortParams)) {
      for (const key of Object.keys(page.sortParams)) {
        const value = page.sortParams[key];
        params = params.append('sort', key + ',' + value);
      }
    }
    if (!_.isUndefined(page.filterParams)) {
      for (const key of Object.keys(page.filterParams)) {
        const value = page.filterParams[key];
        if (value && value !== '') {
          // params = params.append('filter', key + ',' + value );
          params = params.append(key, value);
        }
      }
    }
    return this.http.get(this.apiUrl + '/users', { params: params });
  }

  private create(user: IUser): Observable<IUser> {
    return this.http.post(this.apiUrl + '/users', user).catch(this.handleError);
  }

  private update(user: IUser): Observable<IUser> {
    const url = `${this.apiUrl + '/users'}/${user.id}`;
    return this.http
      .put(url, user)
      .do((data) => this.store.update(data))
      .catch(this.handleError);
  }

  register(user: IUser): Observable<IUser> {
    const url = `${this.apiUrl + '/users/register'}/${user.id}`;
    return this.http
      .put(url, user)
      .do((data) => this.store.update(data))
      .catch(this.handleError);
  }

  public delete(id: number) {
    return this.http.delete<any>(this.apiUrl + '/users/' + id);
  }

  public getAllUsers() {
    return JSON.parse(localStorage.getItem('users')) || [];
  }

  public refreshToken(token) {
    const url = `${this.apiUrl + '/users/refresh-token/'}`;
    return this.http
      .put(url, {
        token: token,
      })
      .catch(this.handleError);
  }

  public getSubordinatePreload(filters: any): Observable<any> {
    let params = new HttpParams();
    for (const key of Object.keys(filters)) {
      const value = filters[key];
      if (value || value === '') {
        params = params.append(key, value);
      }
    }
    return this.http.get(this.apiUrl + '/user/subordinate-preload', {
      params: params,
    });
  }

  public viewSubordinate(id): Observable<any> {
    const url = `${this.apiUrl}/users/view-subordinate/${id}`;
    return this.http.get(url);
  }

  public saveSubordinate(userData: any, newUser: boolean) {
    return newUser
      ? this.createSubordinate(userData)
      : this.updateSubordinate(userData);
  }

  private createSubordinate(userData): Observable<any> {
    const url = `${this.apiUrl}/users/create-subordinate`;
    return this.http.post(this.apiUrl + '/user/create-subordinate', userData);
  }

  private updateSubordinate(userData): Observable<any> {
    const url = `${this.apiUrl}/users/update-subordinate/${userData.user.id}`;
    return this.http.put(url, userData);
  }

  export(page, fileName): Observable<any> {
    const url = '/user/export?offset=' + new Date().getTimezoneOffset();
    return this.getXlsx(url, page, fileName);
  }

  initialize(): IUser {
    // Return an initialized object
    return {
      id: 0,
      username: null,
      email: null,
      password: null,
      repeat_password: null,
      name: null,
      errors: null,
      status: 10,
      last_logged_at: null,
      created_at: null,
      updated_at: null,
    };
  }
}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/services/user.service.ts